import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D6A6FF61-6566-4C1D-BBCC-30E00B0655DD
 * name arrow-top-right-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-top-right-bold-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowTopRightBoldOutlineIcon = createSvgIcon(<><path d="M5.64,4.22H19.78V18.36L15.54,14.12L9.88,19.78L4.22,14.12L9.88,8.46L5.64,4.22M17.66,6.34H10.59L12.71,8.46L7.05,14.12L9.88,16.95L15.54,11.29L17.66,13.41V6.34H17.66Z" /></>, 'ArrowTopRightBoldOutlineIcon');
export default ArrowTopRightBoldOutlineIcon